import { Dictionary } from '../../../utils/types'

export enum DeliveryType {
  Url = 'Url',
  Token = 'Token'
}

export enum DocumentType {
  Pdf = 'Pdf',
  Html = 'Html',
  Tiff = 'Tiff'
}

export enum StatusCode {
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  Error = 'Error',
  Cancelled = 'Cancelled'
}

export enum PdfOpenMode {
  NewTab = 'NewTab',
  Download = 'Download'
}

export type AccountReport = {
  id: string
  company: string
  countryCode: string
  customerReference: string
  officeCode: string
  orderDate: string
  typeCode: string
  documentId?: string
  documentType?: DocumentType
  htmlDocumentId?: string
  isValid: boolean
  statusCode: StatusCode
  deliveryType: DeliveryType
  productName: string
  productCode: string
  deliveryDate?: string
  isFallbackCountry: boolean
  documents: {
    id?: string
    contentType?: string
  }[]
  externalSystemId: string | undefined
  [key: string]: unknown
}

export type ReportInfo = {
  orderId: string
  documentId?: string
  documentType?: DocumentType
  htmlDocumentId?: string
  company: string
  countryCode: string
  customerReference?: string
  officeCode: string
  orderDate: string
  typeCode: string
  expirationDate?: string
  isValid: boolean
  deliveryDate?: string
  productName: string
  productCode: string
  statusCode: StatusCode
  [key: string]: unknown
}

export type Document = {
  customerRequestId?: string
  documentId?: string
  document?: string
  pdfDownloadReportName?: string
}

export type AccountReportsState = {
  page: number
  data: AccountReport[]
  totalPages: number
  filter: string
  reportDetails: Dictionary<ReportInfo>
  htmlDocument: Document | null
  filters: Dictionary<any>
}

export type ArchiveExportColumn = {
  id: string
  name: string
}
